import { FC } from 'react';
import { Controller } from 'react-hook-form';
import { Checkbox, FormControlLabel } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';

import UncheckedIcon from '@/public/icons/checkbox-unchecked.svg';

import { ICheckboxProps } from './Checkbox.props';
import theme from './Checkbox.theme';

export const MyCheckbox: FC<ICheckboxProps> = ({
  control,
  label = '',
  name = '',
}): JSX.Element => {
  return (
    <ThemeProvider theme={theme}>
      <Controller
        name={name}
        control={control}
        defaultValue={false}
        render={({ field }) => (
          <FormControlLabel
            label={label}
            control={
              <Checkbox
                {...field}
                icon={<UncheckedIcon className="w-full" />}
                checked={field.value}
                onChange={e => field.onChange(e.target.checked)}
              />
            }
          />
        )}
      />
    </ThemeProvider>
  );
};
